"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const IconOuterWrapper = styled_components_1.default.span `
  position: relative;
  height: 1rem;
  width: 1.3rem;
  display: inline-block;
`;
const IconInnerWrapper = styled_components_1.default.span `
  position: absolute;
  top: -1px;
  right: -2px;
  margin-right: 5px;
  display: block;
  width: 24px;
  height: 24px;
`;
// Because AtlasKit icons are broken and don't align itself properly
exports.Icon = ({ children }) => (React.createElement(IconOuterWrapper, null,
    React.createElement(IconInnerWrapper, null, children)));
